<template>
  <div class="rule-box num-players">
    <!-- Min participants -->
    <label class="field min" v-for="player in maxPlayersTeam" :key="player[role]">
      <h3 class="min-players numbers" :class="rule.min_players_by_role[role]? 'hide': 'show'">{{player}}</h3>
      <input v-if="rule.min_players_by_role[role] == null" type="radio" name="default" :value="player" v-model="rule.min_players_by_role[role]">
      <input v-else type="radio" name="default" :value="player" v-model="rule.max_players_by_role[role]">
    </label>

    <!-- show Min Max participants -->
    <span class="min-num" v-if="rule.min_players_by_role[role]" @click="changeMinValue()"><span :class="rule.min_players_by_role[role]? 'active' : ''" class="min-players numbers">{{rule.min_players_by_role[role]}}</span><div class="limit min">MIN</div>
    </span>
    <span class="hyphen" v-if="rule.min_players_by_role[role]">-</span>
    <span class="max-num" v-if="rule.max_players_by_role[role]" @click="changeMaxValue()"><span :class="rule.max_players_by_role[role]? 'active' : ''" class="min-players numbers">{{rule.max_players_by_role[role]}}</span><div class="limit min">MAX</div>
    </span>

    <!-- Max participants -->
    <label class="field max" v-for="player in maxPlayersTeam" :key="player[role]" v-if="rule.min_players_by_role[role] && !rule.max_players_by_role[role]" :class="[player === rule.max_players_by_role[role] ? 'active' : '']">
      <h3 class="min-players numbers" :class="parseInt(player) > rule.min_players_by_role[role] ? 'show': 'hide'">{{player}}</h3>
      <input v-if="!rule.max_players_by_role[role]" type="radio" name="default" :value="player" v-model="rule.max_players_by_role[role]">
    </label>
  </div>
</template>
<script>
import { DataState } from '@/state'

export default {
  props: {
    rule: {
      type: Object,
      required: true
    },
    role: {
      type: String
    }
  },
  data () {
    return {
      state: DataState.newLoading(),
      maxPlayersTeam: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']
    }
  },
  mounted () {
  },
  methods: {
    changeMinValue () {
      this.rule.min_players_by_role[this.role] = null
      this.rule.max_players_by_role[this.role] = null
    },
    changeMaxValue () {
      this.rule.max_players_by_role[this.role] = null
    }
  }
}
</script>
